<template>
  <div :class="googleMapContainerClass">
    <slot name="header"></slot>
    <slot name="search"></slot>
    <slot name="listing"></slot>
    <slot name="map"></slot>
  </div>
</template>

<script>

export default {
  name: 'googleMap',
  props: {
    googleMapContainerClass: {
      type: String
    }
  }
}
</script>
